import React from 'react';
import fetchPonyfill from 'fetch-ponyfill';
import styled from 'styled-components';
import ReCAPTCHA from "react-google-recaptcha";


/**
 * Módulo para utilização do método `fetch` que ainda não funciona da forma correta no EDGE, mesmo a Microsoft dizendo que sim.
 */
const {fetch} = fetchPonyfill();

const recaptchaRef = React.createRef();

/**
 * Componente de formulário, será o mesmo para todas as landing pages.
 */

const TextoCallToAction = styled.pre`
	font-size: 1.4rem;
	font-family: "Open Sans", sans-serif;
	color: inherit;
	font-weight: 700;
	line-height: 1.4;
	white-space: pre-line;
	word-wrap: break-word;

	a {
		color: inherit;
		font-style: italic;
	}
`;

const RetornoInvalidoFormulario = styled.div`
	  font-size: 20px;
    padding: 0;
    color: #fff;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

		span{
			padding: 0;
			margin-top: 10px;
			width: 200px;
			display: block;
			text-decoration: underline;
			cursor: pointer;
		}
`;
class Form extends React.Component {
	/**
	 * Cria o estado e a referência para o formulário.
	 * @param props
	 */
	constructor(props) {
		super(props);

		/**
		 * Referência para o elemento do formulário
		 * @type {{current: HTMLElement}}
		 */
		this.form = React.createRef();

		/**
		 *
		 * @type {object}
		 * @property {boolean} loading
		 * @property {string} valorRetorno Link para redirecionar após envio do formulário, ou texto para colocar no lugar do formulário após o envio.
		 */
		this.state = {
			loading: false,
			valorRetorno: false,
			respostaValida: true,
		}

		this.onSubmit = this.onSubmit.bind( this );
	}

	/**
	 * Envia os dados para cadastro do contato no sistema.
	 * Após teste reCAPTCHA ser executado
	 */
	onSubmit() {
		let formData = new FormData(this.form.current);

		this.setState({
			loading: true
		}, () => {
			fetch(this.props.action, {
				method: "POST",
				cache: "no-cache",
                body: formData
			})
			.then(r => {
				if (r.status === 500) {

				}

				return r.json();
			})
			.then(r => {

				this.setState({
					loading: false
				});


				if (r.ok) {
					if (dadosLandingPage.idTemplate === '1') {
						let { valorRetorno } = this.props;
						if (this.props.tipoRetorno === 'redirect') {
							window.location.href = valorRetorno;
						} else if (this.props.tipoRetorno === 'message') {
							this.setState({ valorRetorno });
						} else {

						}
					} else {
						this.setState({ valorRetorno: true });
						if(this.props.callback) this.props.callback();
					}
				} else {
					this.setState({ respostaValida: false })
				}
			})
		})
	}


	/**
	 * Renderiza componente.
	 * @returns {ReactElement}
	 */
	render() {
		let barCount = ' '.repeat(12).split(' '),
			loadingOptions = {
				bar: {
					width: 5,
					height: 15,
					x: 47.5,
					y: 22.5,
					rx: 4.8,
					ry: 2.3,
					fill: 'currentColor'
				},
				animate: {
					dur:"1s",
					keyTimes:"0;1",
					repeatCount:"indefinite",
					values:"1;0",
					attributeName: "opacity"
				}
			}
		;

		return (
			<form className={this.props.className} method="post" ref={this.form}
				onSubmit={(e) => recaptchaRef.current.execute(e.preventDefault())}
			>
				<ReCAPTCHA
					/** Realiza o teste reCAPTCHA de forma invisivel
					 *  @return `this.onSubmit`
					*/
					ref={recaptchaRef}
					sitekey="6LdxAJcqAAAAAHEGrchevfdUjQPi_PaJ8p9B1CUE"
					size="invisible"
					onChange={this.onSubmit}
					style={{display: "none"}}
				/>
				{this.state.valorRetorno ? (
					dadosLandingPage.idTemplate === '1'
						? <TextoCallToAction>{this.state.valorRetorno}</TextoCallToAction>
						:
							dadosLandingPage.campos.retornoForm === 'Mostrar mensagem de retorno'
								?
									<TextoCallToAction>
										{dadosLandingPage.campos.mensagem}
									</TextoCallToAction>
								: dadosLandingPage.campos.retornoForm === 'Download de arquivo'
									?
										<TextoCallToAction>
                                            {dadosLandingPage.campos.mensagem} <br/><br/>
											<a
												href={dadosLandingPage.campos.file}
												target="_blank"
												rel="noopener noreferrer"
											>
												Download
											</a>
										</TextoCallToAction>
									:
										<TextoCallToAction>
											Agradecemos o cadastro! <br/>
											<a href={
												/http/.test(dadosLandingPage.campos.url)
													? dadosLandingPage.campos.url
													: `http://www.${dadosLandingPage.campos.url}`

												}
												target="_blank"
												rel="noopener noreferrer"
											>
												Clique aqui
											</a>
										</TextoCallToAction>
				) : !this.state.loading ? (
					<React.Fragment>

						{
							!this.state.respostaValida ? (
								<RetornoInvalidoFormulario>
									Não foi possível realizar sua inscrição no momento.
									<span onClick={() => window.location.reload(true)}>
										Tentar novamente
									</span>
								</RetornoInvalidoFormulario>
							) : (
								this.props.children
							)
						}
					</React.Fragment>
				) : (
					<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" width="100" height="100">
						{barCount.map((_, i) =>
							<rect key={i} {...loadingOptions.bar} transform={i ? 'rotate('+ (30 * i) +' 50 50)' : null}>
								<animate {...loadingOptions.animate} begin={((-barCount.length + i + 1)/barCount.length) + "s"} />
							</rect>
						)}
					</svg>
				)}
			</form>
		)
	}
}

export default Form
